<script setup lang="ts">
  const { t, tmResolved } = useResolvedI18n()
  const localePath = useLocalePath()

  useHead({ title: () => t('research.title') })

  const infraFeatures = computed(() => tmResolved<string[]>('research.infra.features'))
  const adEquipment = computed(() => tmResolved<string[]>('research.labs.ad.equipment'))
  const icEquipment = computed(() => tmResolved<string[]>('research.labs.ic.equipment'))
  const directions = computed(() => tmResolved<Array<{ title: string; desc: string }>>('research.directions.items'))
</script>

<template>
  <section
    class="page-banner"
    style="
      background-image: url('https://www.sanyau.edu.cn/_upload/article/images/85/86/5319f3c5498fb994233849b342dd/99b21cb7-8944-4b64-857c-bb9455d4292c.jpg');
    "
  >
    <h2>{{ t('research.banner') }}</h2>
    <div class="breadcrumb">
      <NuxtLink :to="localePath('/')">{{ t('common.home') }}</NuxtLink>
      &gt; {{ t('research.breadcrumb') }}
    </div>
  </section>

  <section class="content-section">
    <div class="container">
      <div class="full-content">
        <div class="content-card">
          <div class="section-title">{{ t('research.infra.title') }}</div>
          <div class="section-sub">{{ t('research.infra.intro') }}</div>

          <div class="stats-grid">
            <div class="stat-item" style="color: var(--white)">
              <h3 style="font-size: 32px">{{ t('research.infra.stat0Value') }}</h3>
              <p>{{ t('research.infra.stat0Label') }}</p>
            </div>
            <div class="stat-item" style="color: var(--white)">
              <h3 style="font-size: 32px">{{ t('research.infra.stat1Value') }}</h3>
              <p>{{ t('research.infra.stat1Label') }}</p>
            </div>
            <div class="stat-item" style="color: var(--white)">
              <h3 style="font-size: 32px">{{ t('research.infra.stat2Value') }}</h3>
              <p>{{ t('research.infra.stat2Label') }}</p>
            </div>
            <div class="stat-item" style="color: var(--white)">
              <h3 style="font-size: 32px">{{ t('research.infra.stat3Value') }}</h3>
              <p>{{ t('research.infra.stat3Label') }}</p>
            </div>
          </div>

          <ul class="flex flex-col gap-2">
            <li v-for="(item, i) in infraFeatures" :key="i">{{ item }}</li>
          </ul>
        </div>

        <div class="content-card">
          <h3>{{ t('research.labs.title') }}</h3>
          <p>{{ t('research.labs.intro') }}</p>

          <div class="program-cards" style="margin-top: 20px">
            <div class="program-card">
              <div class="program-card-header">
                <h3 class="text-white!">{{ t('research.labs.ad.title') }}</h3>
                <p class="text-white!">{{ t('research.labs.ad.subtitleEn') }}</p>
              </div>
              <div class="program-card-body">
                <h4>{{ t('research.labs.equipmentLabel') }}</h4>
                <ul style="padding-left: 0">
                  <li v-for="(item, i) in adEquipment" :key="i">{{ item }}</li>
                </ul>
                <h4>{{ t('research.labs.capabilityLabel') }}</h4>
                <p>{{ t('research.labs.ad.capability') }}</p>
              </div>
            </div>

            <div class="program-card">
              <div class="program-card-header" style="background: linear-gradient(135deg, #205295, #2c74b3, #00b894)">
                <h3 class="text-white!">{{ t('research.labs.ic.title') }}</h3>
                <p class="text-white!">{{ t('research.labs.ic.subtitleEn') }}</p>
              </div>
              <div class="program-card-body">
                <h4>{{ t('research.labs.equipmentLabel') }}</h4>
                <ul style="padding-left: 0">
                  <li v-for="(item, i) in icEquipment" :key="i">{{ item }}</li>
                </ul>
                <h4>{{ t('research.labs.capabilityLabel') }}</h4>
                <p>{{ t('research.labs.ic.capability') }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="content-card">
          <h3>{{ t('research.directions.title') }}</h3>
          <p>{{ t('research.directions.intro') }}</p>

          <div class="features-grid flex flex-col gap-10" style="margin-top: 20px">
            <div v-for="(item, i) in directions" :key="i" class="flex flex-col gap-2">
              <div>{{ item.title }}</div>
              <div>{{ item.desc }}</div>
            </div>
          </div>
        </div>

        <div class="content-card">
          <h3>{{ t('research.intl.title') }}</h3>
          <p>{{ t('research.intl.intro') }}</p>

          <div class="highlight-box">
            <h3>{{ t('research.intl.qualityTitle') }}</h3>
            <p>{{ t('research.intl.quality1') }}</p>
            <p>{{ t('research.intl.quality2') }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
